module.exports = __webpack_public_path__ + "img/lock.847d4763.svg";